<template>
  <v-chip :color="value.color" :prepend-icon="value.icon" data-cy="route-status" variant="outlined">
    {{ value.name }}
  </v-chip>
</template>

<script>
import documentRouteStatusList from "@/constants/documentRouteStatusList";
const defaultValue = documentRouteStatusList[0];

export default {
  props: {
    id: Number,
  },

  computed: {
    value() {
      return this.id ? documentRouteStatusList.find(x => x.id === this.id) : defaultValue;
    },
  },
};
</script>
